import { useEffect, useMemo, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import { useDispatch, useSelector } from "react-redux";
import {
  getDashboardCount,
  getDashboardGraph,
} from "../../Redux/Actions/dashboardActions";
import GraphComponent from "./graphComponent";
import SelectInput from "../../Global Functions/selectInput";
import { useNavigate } from "react-router-dom";
import { icons } from "../../icons";

const ViewDashboard = () => {
  const dispatch = useDispatch();

  const [graphData, setGraphData] = useState({
    type: "month",
    graphfor: "projects",
  });

  useEffect(() => {
    dispatch(getDashboardCount());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getDashboardGraph(graphData));
  }, [graphData, dispatch]);

  const timeDropdown = ["year", "month", "week"];

  const graphForOptions = [
    "projects",
    "properties",
    "bookings",
    "events",
    "offers",
    "users",
    "builders",
  ];

  const colorPalette = [
    "#36A2EB",
    "#FF6384", // Red
    "#FFCE56", // Yellow
    "#4BC0C0", // Teal
    "#9966FF", // Purple
    "#F67019", // Orange
    "#00A36C", // Green
    "#C71585", // Violet Red
    "#A52A2A", // Brown
  ];

  const { dashboardCount, dashboardGraph } = useSelector(
    (state) => state.dashboard || {}
  );

  const donutData = {
    labels: [
      "Users",
      "Builders",
      "Projects",
      "Properties",
      "Bookings",
      "Meetings",
      "Refunds",
      "Events",
    ],

    datasets: [
      {
        label: "Dashboard Stats",
        data: [
          dashboardCount?.data?.users_count || 0,
          dashboardCount?.data?.builders_count || 0,
          dashboardCount?.data?.projects_count || 0,
          dashboardCount?.data?.property_count || 0,
          dashboardCount?.data?.booking_count || 0,
          dashboardCount?.data?.meetings_count || 0,
          dashboardCount?.data?.refund_count || 0,
          dashboardCount?.data?.event_count || 0,
        ],
        backgroundColor: [
          "#FF6384",
          "#36A2EB",
          "#FFCE56",
          "#4BC0C0",
          "#9966FF",
          "#FF9F40",
          "#00C49F",
          "#FF6F61",
        ],
      },
    ],
  };

  const sampleOptions = {
    borderColor: "rgb(67,70,80)",
    responsive: true,
    plugins: {
      legend: {
        display: "flex",
        position: "bottom",

        labels: {
          color: "white",
        },
      },
    },
    datalabels: {
      color: "white",

      font: {
        size: 16,
      },
      formatter: (value) => value,
    },
  };

  // const propLabelArray = dashboardCount?.data?.property_chart.map(
  //   (item) => item.label
  // );

  const propDataArray = dashboardCount?.data?.property_chart.map(
    (item) => item.value
  );

  const propLabelArrayOverall = useMemo(() => {
    return dashboardGraph?.data?.result.map((item) => item.label);
  }, [dashboardGraph]);

  const propDataArrayOverall = useMemo(() => {
    return dashboardGraph?.data?.result.map((item) => item.total);
  }, [dashboardGraph]);

  // const barData = {
  //   labels: propLabelArray,
  //   datasets: [
  //     {
  //       data: propDataArray,
  //       label: "Property Data",
  //       borderRadius: 5,
  //       barThickness: 40,
  //       backgroundColor: propDataArray?.map(
  //         (_, index) => colorPalette[index % colorPalette.length]
  //       ),
  //     },
  //   ],
  // };

  const overAllBarData = {
    labels: propLabelArrayOverall,
    datasets: [
      {
        data: propDataArrayOverall,
        label: "Total",

        borderRadius: 5,
        barThickness: 25,
        backgroundColor: propDataArray?.map(
          (_, index) => colorPalette[index % colorPalette.length]
        ),
      },
    ],
  };

  const barOptionsOverAll = {
    scales: {
      x: {
        ticks: {
          color: "white",
          font: {
            size: 12,
          },
        },
        grid: {
          color: "white",
          borderColor: "#888888",
        },
      },
      y: {
        ticks: {
          color: "white",
          font: {
            size: 12,
          },
          stepSize: 1,
          callback: function (value) {
            return Number.isInteger(value) ? value : null;
          },
        },
        grid: {
          color: "white",

          borderColor: "#888888",
        },
      },
    },
    plugins: {
      legend: {
        labels: {
          color: "white",
        },
        position: "bottom",
      },
    },
  };

  // scales: {
  //   x: {
  //     grid: {
  //       display: false,
  //     },
  //     ticks: {
  //       color: '#999',
  //     }
  //   },
  //   y: {
  //     grid: {
  //       color: '#eee',
  //     },
  //     ticks: {
  //       font: {
  //         size: 12,
  //       },
  //       color: '#666'
  //     }
  //   }
  // }

  const navigate = useNavigate();

  return (
    <MainLayout>
      <div className="radius25_padding20 bgBlue">
        <div className="dashboard-container">
          <div className="dashboard-cards">
            <div className="dashboard-card">
              <div
                onClick={() => navigate("/manage_users")}
                className="dashboardCard dashboard-text"
              >
                <img src={icons["Card"]} alt="" />
                <div>
                  <h5>Users</h5>
                  <h3>
                    {dashboardCount?.data
                      ? dashboardCount.data.users_count
                      : "0"}
                  </h3>
                </div>
              </div>
              <div
                onClick={() => navigate("/builders")}
                className="dashboardCard dashboard-text"
              >
                <img src={icons["Card"]} alt="" />
                <div>
                  <h5>Builders</h5>
                  <h3>
                    {dashboardCount?.data
                      ? dashboardCount.data.builders_count
                      : "0"}
                  </h3>
                </div>
              </div>
              <div
                onClick={() => navigate("/manage_projects")}
                className="dashboardCard dashboard-text"
              >
                <img src={icons["Card"]} alt="" />
                <div>
                  <h5>Projects</h5>
                  <h3>
                    {dashboardCount?.data
                      ? dashboardCount.data.projects_count
                      : "0"}
                  </h3>
                </div>
              </div>
              <div
                onClick={() => navigate("/manage_properties")}
                className="dashboardCard dashboard-text"
              >
                <img src={icons["Card"]} alt="" />
                <div>
                  <h5>Properties</h5>
                  <h3>
                    {dashboardCount?.data
                      ? dashboardCount.data.property_count
                      : "0"}
                  </h3>
                </div>
              </div>
              <div
                onClick={() => navigate("/bookings")}
                className="dashboardCard dashboard-text"
              >
                <img src={icons["Card"]} alt="" />
                <div>
                  <h5>Bookings</h5>
                  <h3>
                    {dashboardCount?.data
                      ? dashboardCount.data.booking_count
                      : "0"}
                  </h3>
                </div>
              </div>
              <div
                onClick={() => navigate("/meeting")}
                className="dashboardCard dashboard-text"
              >
                <img src={icons["Card"]} alt="" />
                <div>
                  <h5>Meetings</h5>
                  <h3>
                    {dashboardCount?.data
                      ? dashboardCount.data.meetings_count
                      : "0"}
                  </h3>
                </div>
              </div>
              <div
                onClick={() => navigate("/wallet_refund")}
                className="dashboardCard dashboard-text"
              >
                <img src={icons["Card"]} alt="" />
                <div>
                  <h5>Refunds</h5>
                  <h3>
                    {dashboardCount?.data
                      ? dashboardCount.data.refund_count
                      : "0"}
                  </h3>
                </div>
              </div>
              <div
                onClick={() => navigate("/dealsAndOffers")}
                className="dashboardCard dashboard-text"
              >
                <img src={icons["Card"]} alt="" />
                <div>
                  <h5>Coupons</h5>
                  <h3>
                    {dashboardCount?.data
                      ? dashboardCount.data.coupons_count
                      : "0"}
                  </h3>
                </div>
              </div>
              <div
                onClick={() => navigate("/payments")}
                className="dashboardCard dashboard-text"
              >
                <img src={icons["Card"]} alt="" />
                <div>
                  <h5>Payments</h5>
                  <h3>
                    {dashboardCount?.data
                      ? dashboardCount.data.payment_count
                      : "0"}
                  </h3>
                </div>
              </div>
            </div>
            <div className="donut">
              {/* <img className="donut-bg" src={DashboardBackground} alt="" /> */}

              <GraphComponent
                type="doughnut"
                data={donutData}
                options={sampleOptions}
                graphHeading="Admin Stats"
              />
            </div>
          </div>
          <div className="bar_chart1">
            <div className="project-graph dashboard-text">
              <h5 className="margin-0 color-white ">Project Over-All Stats</h5>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <SelectInput
                  value={graphData.type}
                  onChange={(event) =>
                    setGraphData((prevData) => ({
                      ...prevData,
                      type: event.target.value,
                    }))
                  }
                  placeholder="Month"
                  options={
                    Array.isArray(timeDropdown)
                      ? timeDropdown.map((item) => ({
                          label: item.charAt(0).toUpperCase() + item.slice(1),
                          value: item,
                        }))
                      : []
                  }
                ></SelectInput>
                <SelectInput
                  value={graphData.graphfor}
                  onChange={(event) =>
                    setGraphData((prevData) => ({
                      ...prevData,
                      graphfor: event.target.value,
                    }))
                  }
                  placeholder="Projects"
                  options={
                    Array.isArray(graphForOptions)
                      ? graphForOptions.map((item) => ({
                          label: item.charAt(0).toUpperCase() + item.slice(1),
                          value: item,
                        }))
                      : []
                  }
                ></SelectInput>
              </div>
            </div>
            <div className="global_chart">
              <GraphComponent
                type="bar"
                data={overAllBarData}
                options={barOptionsOverAll}
              ></GraphComponent>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default ViewDashboard;
